import * as go from 'gojs';
import { InputPort } from '../../../../gojs/templates/portTemplates/inputPortTemplate';
import { OutputPort } from '../../../../gojs/templates/portTemplates/outputPortTemplate';
import type {
  GrizzlyFeederNodeData,
  MobileUnitBaseNodeData,
  ScreenNodeData,
} from '../../../../gojs/types';

const $ = go.GraphObject.make;

type IOPortAlignmentCallback = (node: any) => go.Spot;
type IOPortAlignment = go.Spot | IOPortAlignmentCallback;
function isSpot(alignment: IOPortAlignment): alignment is go.Spot {
  return alignment instanceof go.Spot;
}
export const getIOPort = (
  alignment: IOPortAlignment,
  io: 'input' | 'output',
) => {
  if (
    isSpot(alignment) &&
    (alignment === go.Spot.Top || alignment === go.Spot.Bottom)
  ) {
    return $(
      go.Panel,
      'Horizontal',
      new go.Binding(
        'itemArray',
        io === 'input' ? 'inputPortArray' : 'outputPortArray',
      ),
      {
        alignment,
        itemTemplate: io === 'input' ? InputPort : OutputPort,
      },
    );
  }

  const bindingCallback = isSpot(alignment)
    ? (node: any) => {
        return node.mirrored
          ? new go.Spot(alignment.opposite().x, alignment.y)
          : alignment;
      }
    : alignment;

  return $(
    go.Panel,
    'Horizontal',
    new go.Binding(
      'itemArray',
      io === 'input' ? 'inputPortArray' : 'outputPortArray',
    ),
    {
      itemTemplate: io === 'input' ? InputPort : OutputPort,
    },
    new go.Binding('alignment', '', bindingCallback),
  );
};

const getPortPanel =
  (prefix: 'D' | 'P') =>
  (
    portIndex: number,
    alignPort: (
      mirrored: boolean,
      portIndex: number,
      decks?: number,
    ) => go.Spot | undefined,
    isVisible: (node: ScreenNodeData & GrizzlyFeederNodeData) => boolean = () =>
      true,
  ) =>
    $(
      go.Panel,
      'Auto',
      new go.Binding('itemArray', `${prefix}${portIndex}`),
      new go.Binding('visible', '', isVisible),
      {
        itemTemplate: OutputPort,
      },
      new go.Binding(
        'alignment',
        '',
        (node: ScreenNodeData & GrizzlyFeederNodeData) => {
          return alignPort(
            node.mirrored,
            portIndex,
            node.nbrOfDecks || node.nbrOfOutputs,
          );
        },
      ),
    );

export const getMobileInputPort = (
  alignPort: (node: MobileUnitBaseNodeData) => go.Spot,
) =>
  $(
    go.Panel,
    'Horizontal',
    new go.Binding('itemArray', 'inputPortArray'),
    {
      itemTemplate: InputPort,
    },
    new go.Binding('alignment', '', alignPort),
  );

export const getMobileOutputPort = (
  portIndex: number,
  align: (
    mirrored: boolean,
    model: string,
    configKey: number,
    portIndex: number,
  ) => go.Spot | undefined,
) =>
  $(
    go.Panel,
    'Auto',
    new go.Binding('itemArray', `P${portIndex}`),
    {
      itemTemplate: OutputPort,
    },
    new go.Binding('visible', '', (node: MobileUnitBaseNodeData) => {
      return node.numberOfPorts > portIndex;
    }),
    new go.Binding('alignment', '', (node: MobileUnitBaseNodeData) => {
      return align(
        node.mirrored,
        node.model,
        node.configuration.configKey,
        portIndex,
      );
    }),
  );

export const getDeckPortPanel = getPortPanel('D');
export const getOutputPortPanel = getPortPanel('P');
